import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

export default class extends Controller {
  static targets = ["group"]

  expandAll(event) {
    event.preventDefault()
    this.groupTargets.forEach((group) => this.collapseFor(group).show())
  }

  collapseAll(event) {
    event.preventDefault()
    this.groupTargets.forEach((group) => this.collapseFor(group).hide())
  }

  collapseFor(group) {
    return Collapse.getInstance(group) || new Collapse(group, { toggle: false })
  }
}
